import { render } from "./my-assets.vue?vue&type=template&id=7bed9c1b&scoped=true"
import script from "./my-assets.vue?vue&type=script&lang=js"
export * from "./my-assets.vue?vue&type=script&lang=js"

import "./my-assets.vue?vue&type=style&index=0&id=7bed9c1b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bed9c1b"]])

export default __exports__